import React from 'react';
import pokemonlogo from '../../img/pokemonlogo.svg.png';

const Header = () => (
    <header className='center'>
      <img src={pokemonlogo} alt=''/>
    </header>
);

export default Header;
